import { MarketDetails, CountryOption } from '../../types';
import { MarketListItem } from './market-list-item';

type MarketListItemsProps = {
  readonly markets: MarketDetails[];
  readonly countries: CountryOption[];
};

export function MarketListItems({ markets, countries }: MarketListItemsProps) {
  return (
    <>
      {markets.map((market) => (
        <MarketListItem
          key={market.id}
          market={market}
          country={
            countries.find((c) => c.value === market.location) ?? {
              label: 'Unknown',
              value: market.location,
            }
          }
        />
      ))}
    </>
  );
}
